import script from "./PlayoutListItemV2.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutListItemV2.vue?vue&type=script&setup=true&lang=js"

import "./PlayoutListItemV2.vue?vue&type=style&index=0&id=a2424d04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2424d04"]])

export default __exports__